import { GAP_RATIO, DRAW_RATIO } from "../constant";


/**
 * 初始化data数据
 * @returns 
 */
function getDefaultData () {
  return {
    // srgb的数据
    SRGB_List: [],
    // 绘制配置
    drawOption: {
      width: null,
      height: null,
      autoHeight: false,
      gapRatio: GAP_RATIO,
      drawRatio: DRAW_RATIO,
    },
    // ctx画布
    bitmapCtx: null,
    // 绘制的节点
    containerDom: null,
    // listenerMap
    listenerMap: new Map()
  }
}

export default class Shapes {
  constructor(props) {
    const data = props || {};

    this.init(data);
  }

  data = getDefaultData()

  init(data) {
    this.initData(data);
  }
  
  initData(data) {
    const { SRGB_List, drawOption, containerDom, originImgData } = data

    this.data = {
      ...this.data,
      SRGB_List,
      drawOption,
      containerDom,
      originImgData,
    }
  }

  /**
   * 等比计算点位图高度
   * @param {Number} containerWidth 
   * @returns 
   */
  calContainerSize(containerWidth, containerHeight) {
    const { width, height } = this.data.originImgData;
    const scale = height / width;

    // 宽大于高 横向
    if (width > height) {
      return {
        containerWidth,
        containerHeight: Math.floor(scale * containerWidth)
      }
    }

    // 高大于等于宽 竖向
    return {
      containerWidth: Math.floor(containerHeight / scale),
      containerHeight
    }
  }

  /**
   * 根据需要绘制的点数与留白比例计算每个色块长度数值
   * @param {dom} containerWidth 需要绘制的dom宽度
   * @param {Number} imgWidth 原图宽度
   * @param {Number} gapRatio 留白比例
   * @param {Number} drawRatio 绘制倍数
   * @returns 
   */
    calBlockOption(containerWidth, imgWidth, gapRatio, drawRatio) {
      // 点位图有色部分 + 留白部分整体长度
      const blockAndGrapWidth = containerWidth  * drawRatio / imgWidth;
      // 有色位图长度
      const blockWidth =  Number(
        (blockAndGrapWidth * (1 / (1 + gapRatio))).toFixed(2)
      );
      // 间隙长度
      const gapWidth =  Number((blockAndGrapWidth - blockWidth).toFixed(2));
  
      return {
        blockWidth, // 单个block长度
        gapWidth, // 留白长度
        blockAndGrapWidth // block长度 + 留白长度
      }
    }

    // 订阅消息
    addEventListener(evName, callback) {
      const { listenerMap } = this.data;

      if (listenerMap.has(evName)) {
        listenerMap.get(evName).push(callback)
      } else {
        listenerMap.set(evName, [ callback ])
      }
    }
  
    // 发布消息
    dispatch(evName, data) {
      const callbackList = this.data.listenerMap.get(evName);

      if (!Array.isArray(callbackList)) return;

      callbackList.forEach(callback => {
        callback && callback(data)
      })
    }
}